import { LetterDraftFormValues } from 'assets/js/pages/engage/letters/types';
import { EngageMessageChannel, EngageMessageSettings } from 'types/domain';

const PERSONALIZED_LETTER_DEBOUNCE = 750;
const PERSONALIZED_LETTER_CONTACT_PARAMS = {
    channel: 'letter' as EngageMessageChannel,
    per_page: 200,
    include: 'mailPieces',
    sortBy: 'first_name',
};
const LETTER_START_COST = 1.95;
const PLUS_LETTER_START_COST = 1.75;
const LETTER_FREE_PROOF_PER_MONTH = 5;

const POSTAGE_TYPES: {
    [key in EngageMessageSettings['postage_type']]: LetterDraftFormValues['letterSettings']['postageType'];
} = {
    usps_standard: {
        id: 'standard',
        label: 'USPS Standard Class Mail',
        value: 'usps_standard',
    },
    usps_first_class: {
        id: 'usps_first_class',
        label: 'USPS First Class Mail',
        value: 'usps_first_class',
    },
};

export {
    PERSONALIZED_LETTER_DEBOUNCE,
    PERSONALIZED_LETTER_CONTACT_PARAMS,
    LETTER_START_COST,
    PLUS_LETTER_START_COST,
    LETTER_FREE_PROOF_PER_MONTH,
    POSTAGE_TYPES,
};
